<template>
  <div class="layout">
    <el-row class="tac" type="flex">
      <el-col :span="24" class="layout-header">
        <div class="layout-header-logo">
          <img :src="lkdLogo" />
        </div>
        <div style="float: right; display: flex; align-items: center; height: 100%">
          <span class="layout-header-font" @click="跳转预约下载()" style="color: white;">
            <el-badge :is-dot="hasUnreadInformation" style=" line-height:24px">
              <i class="el-icon-download" style="color: white;font-size: 16px;"></i>

              预约处理
            </el-badge>
          </span>
          <span style="margin-right:10px">
            <img style="width: 20px;height: 18px;margin-top: 1px;margin-right: -3px;" src="../../assets/images/home.png"
              alt="">
          </span>
          <span class="layout-header-font" style="color: white ;">
            {{ shopName }}
          </span>
          <span style="margin-right:10px">
            <img style="width: 27px;height: 27px; margin-top: -6px;margin-right: -7px;vertical-align: middle;"
              src="../../assets/images/personal.png" alt="">
          </span>
          <span class="layout-header-font" style="color: white; padding-right: 0px;">
            {{ managername }}
          </span>
          <el-popover placement="bottom" width="150" trigger="hover">
            <el-row>
              <el-col :span="24" style="padding-left: 10px;">
                <el-button size="small" type="text" icon="el-icon-setting" class="layout-header-font btnSty"
                  @click="centerDialogVisible = true">
                  修改密码
                </el-button>
              </el-col>
              <!-- <el-col :span="24" style="padding-left: 10px">
                <el-button size="small" type="text" icon="el-icon-switch-button" @click="logout"
                  class="layout-header-font btnSty">注销</el-button>
              </el-col> -->
            </el-row>
            <span class="layout-header-font user" slot="reference" style="margin-right:10px">
              <img
                style="width: 21px;height: 21px;margin-top: 1px;margin-right:0px;margin-left: 3px;vertical-align: text-bottom;"
                src="../../assets/images/down.png" alt="">
            </span>
          </el-popover>
          <span style="margin-right:10px;color:#bbb">|</span>
          <span style="margin-right: 10px; cursor: pointer;" @click="logout">
            <img style="width: 17px; height: 18px; margin-top: 3px; vertical-align: sub;"
              src="../../assets/images/out.png" alt="">
          </span>
          <span
            style="margin-right: 30px; font-size: 14px;font-weight: bold;margin-top: 2px; color:#fff; cursor: pointer;"
            @click="logout">
            退出
          </span>
        </div>
      </el-col>
    </el-row>
    <!--  -->
    <el-row class="tac" type="flex" style="min-height: 100%">
      <el-col :span="3" class="layout-menu-left">
        <el-scrollbar class="page-scroll">
          <el-menu style="width: 100%" ref="mainMenu" @select="selectMenu" class="el-menu-demo"
            background-color="#464c5b" text-color="lightgray" :unique-opened="true" :default-active="activeIndex">
            <el-submenu index="1" v-show="menu_dic[100]">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span slot="title">销售订单管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="entryOrderList" style="min-width: 100px" v-show="menu_dic[10000]">
                  录入订单
                </el-menu-item>
                <el-menu-item index="remarksReview" style="min-width: 100px" v-show="menu_dic[10001]">
                  备注审核
                </el-menu-item>
                <el-menu-item index="reducedOrder" style="min-width:100px" v-show="menu_dic[10008]">
                  减单审核
                </el-menu-item>
                <el-menu-item index="NewOrderList" style="min-width: 100px" v-show="menu_dic[10002]">
                  待送订单
                </el-menu-item>
                <el-menu-item index="OrderConfirmList" style="min-width: 100px" v-show="menu_dic[10003]">
                  待确认订单
                </el-menu-item>
                <el-menu-item index="NoActualOrderConfirmation" style="min-width: 100px" v-show="menu_dic[10016]">
                  无实发订单确认
                </el-menu-item>
                <el-menu-item index="HistoryOrderList" style="min-width: 100px" v-show="menu_dic[10004]">
                  历史订单
                </el-menu-item>
                <el-menu-item index="AllOrderList" style="min-width: 100px" v-show="menu_dic[10006]">
                  全部订单
                </el-menu-item>
                <el-menu-item index="SupplementOrder" style="min-width: 100px" v-show="menu_dic[10007]">
                  补单
                </el-menu-item>
                <el-menu-item index="priceAudit" style="min-width:100px" v-show="menu_dic[10009]">
                  价格审核
                </el-menu-item>
                <el-menu-item index="purchaseAudit" style="min-width:100px" v-show="menu_dic[10010]">
                  采购价审核
                </el-menu-item>
                <el-menu-item index="skuAudit" style="min-width:100px" v-show="menu_dic[10011]">
                  SKU审核
                </el-menu-item>
                <el-menu-item index="salesPriceReview" style="min-width:100px" v-show="menu_dic[10013]">
                  销售价复核
                </el-menu-item>
                <el-menu-item index="searchSellOrder" style="min-width:100px" v-show="menu_dic[10012]">
                  订单查询
                </el-menu-item>
                <el-menu-item index="priceAdjustmentRecordsList" style="min-width:100px" v-show="menu_dic[10014]">
                  订单调价申请记录
                </el-menu-item>
                <el-menu-item index="lowPriceOrderList" style="min-width:100px" v-show="menu_dic[10015]">
                  单外订单
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="11" v-show="menu_dic[118]">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span slot="title">第三方配送订单</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="supplierSendOrder" style="min-width:100px" v-show="menu_dic[10005]">
                  转换订单
                </el-menu-item>
                <el-menu-item index="DSOrder" style="min-width:100px" v-show="menu_dic[11801]">待送订单</el-menu-item>
                <el-menu-item index="DSOrderConfirmList" style="min-width:100px" v-show="menu_dic[11802]">
                  待确认订单
                </el-menu-item>
                <el-menu-item index="DSHistoryOrderList" style="min-width:100px" v-show="menu_dic[11803]">
                  历史订单
                </el-menu-item>
                <el-menu-item index="DSOrdeInquiry" style="min-width:100px" v-show="menu_dic[11804]">订单查询</el-menu-item>
                <el-menu-item index="DSUnpriceOrderDetail" style="min-width:100px" v-show="menu_dic[11805]">
                  未定价订单详情列表
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="2" v-show="menu_dic[101]">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span slot="title">采购订单管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="purchaseAddProduct" style="min-width:100px" v-show="menu_dic[10102]"
                  v-if="PRICE_MODE == 2">
                  采购产品
                </el-menu-item>
                <el-menu-item index="emergencyOrder" style="min-width:100px" v-show="menu_dic[10103]"
                  v-if="PRICE_MODE == 2">
                  应急下单
                </el-menu-item>
                <el-menu-item index="shopCar" style="min-width:100px" v-show="menu_dic[10104]" v-if="PRICE_MODE == 2">
                  购物车
                </el-menu-item>
                <el-menu-item index="s_NewOrderList" style="min-width:100px" v-show="menu_dic[10100]">
                  待送订单
                </el-menu-item>
                <el-menu-item index="shopConfirmOrderList" style="min-width:100px" v-show="menu_dic[10105]">
                  待确认订单
                </el-menu-item>
                <el-menu-item index="s_HistoryOrderList" style="min-width:100px" v-show="menu_dic[10101]">
                  历史订单
                </el-menu-item>
                <el-menu-item index="searchShopOrder" style="min-width:100px" v-show="menu_dic[10106]">
                  订单查询
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="3" v-show="menu_dic[102]">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span slot="title">制单管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="salesOrderAudit" style="min-width: 100px" v-show="menu_dic[10201]">
                  销售单审核（转采购）
                </el-menu-item>
                <el-menu-item index="purchaseOrder" style="min-width: 100px" v-show="menu_dic[10200]">
                  销售转采购
                </el-menu-item>
                <el-menu-item index="totalOutWare" style="min-width: 100px" v-show="menu_dic[10202]">
                  销售汇总单
                </el-menu-item>
                <el-menu-item index="shoppingDocument" style="min-width: 100px" v-show="menu_dic[10203]">
                  采买单管理
                </el-menu-item>
                <el-menu-item index="sendingDocumentSupplier" style="min-width: 100px" v-show="menu_dic[10204]">
                  配送单管理(司渊)
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="29" v-show="menu_dic[125]">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span slot="title">分拣配送</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="separateDoc" style="min-width: 100px" v-show="menu_dic[12501]">分菜单管理</el-menu-item>
                <el-menu-item index="sendingDocument" style="min-width: 100px" v-show="menu_dic[12502]">
                  配送单管理
                </el-menu-item>
                <el-menu-item index="lineSet" style="min-width: 100px" v-show="menu_dic[12503]">线路管理</el-menu-item>
                <el-menu-item index="carSet" style="min-width: 100px" v-show="menu_dic[12504]">车辆管理</el-menu-item>
                <el-menu-item index="monitor" style="min-width: 100px" v-show="menu_dic[12505]">物流监控</el-menu-item>
                <el-menu-item index="deliveryTaskProgress" style="min-width: 100px" v-show="menu_dic[12509]">
                  配送任务进度
                </el-menu-item>
                <el-menu-item index="s_print" style="min-width: 100px" v-show="menu_dic[12506]">打印标签</el-menu-item>
                <el-menu-item index="sortingGroupManagement" style="min-width: 100px" v-show="menu_dic[12507]">
                  分拣组管理
                </el-menu-item>
                <el-menu-item index="sortingVarianceQuery" style="min-width: 100px" v-show="menu_dic[12508]">
                  分拣差异查询
                </el-menu-item>
                <el-menu-item index="turnoverManage" style="min-width:100px" v-show="menu_dic[10509]">
                  周转筐管理
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="4" v-show="menu_dic[103]">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span slot="title">价格管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="quote" style="min-width: 100px" v-show="menu_dic[10300]">报价</el-menu-item>
                <el-menu-item index="comparePrice" style="min-width: 100px" v-show="menu_dic[10305]">比价列表</el-menu-item>
                <el-menu-item index="purchaseQuotation" style="min-width: 100px" v-show="menu_dic[10303]">
                  供应商报价记录
                </el-menu-item>
                <el-menu-item index="priceGroup" style="min-width: 100px" v-show="menu_dic[10304]">销售报价分组</el-menu-item>
                <el-menu-item index="expressSalePricing" style="min-width: 100px" v-show="menu_dic[10307]">
                  快捷销售定价
                </el-menu-item>
                <el-menu-item index="customerPricingReview" style="min-width: 100px" v-show="menu_dic[10306]">
                  客户定价复核
                </el-menu-item>
                <el-menu-item index="businessReferencePrice" style="min-width: 100px" v-show="menu_dic[10308]">
                  业务参考价
                </el-menu-item>
                <el-menu-item index="salesPriceInquiry" style="min-width: 100px" v-show="menu_dic[10309]">
                  销售价格查询
                </el-menu-item>
                <el-menu-item index="purchasePriceInquiry" style="min-width: 100px" v-show="menu_dic[10310]">
                  采购价格查询
                </el-menu-item>
                <el-menu-item index="customerPricingDifferenceQuery" style="min-width: 100px" v-show="menu_dic[10311]">
                  客户定价差异查询
                </el-menu-item>
                <el-menu-item index="priceRules" style="min-width: 100px" v-show="menu_dic[10301]">
                  价格规则
                </el-menu-item>
                <el-menu-item index="priceIncreaseRelationshipManagement" style="min-width: 100px"
                  v-show="menu_dic[10302]">
                  加价关系管理
                </el-menu-item>
                <el-menu-item index="supplierPrice" style="min-width: 100px" v-show="menu_dic[10312]">
                  成本中心
                </el-menu-item>

                <el-menu-item index="orderProfitAnalysis" style="min-width: 100px" v-show="menu_dic[10313]">
                  订单利润分析
                </el-menu-item>

                <el-menu-item index="projectProfitAnalysis" style="min-width: 100px" v-show="menu_dic[10314]">
                  项目利润分析
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="5" v-show="menu_dic[104]">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span slot="title">审核</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="delayedReview" style="min-width: 100px" v-show="menu_dic[10400]">
                  订单延时审核列表
                </el-menu-item>
                <el-menu-item index="returnAudit" style="min-width: 100px" v-show="menu_dic[10401]">退货审核</el-menu-item>
                <el-menu-item index="stockCheckAudit" style="min-width: 100px" v-show="menu_dic[10402]">
                  盘库审核
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="6" v-show="menu_dic[105]">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span slot="title">仓库管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="stockEnter" style="min-width: 100px" v-show="menu_dic[10500]">入库</el-menu-item>
                <el-menu-item index="stockOut" style="min-width: 100px" v-show="menu_dic[10501]">出库</el-menu-item>
                <el-menu-item index="pickingList" style="min-width:100px" v-show="menu_dic[10514]">拣货单</el-menu-item>
                <el-menu-item index="temporaryStock" style="min-width:100px" v-show="menu_dic[10515]">临时仓</el-menu-item>
                <el-menu-item index="returnStock" style="min-width:100px" v-show="menu_dic[10516]">退货仓</el-menu-item>
                <el-menu-item index="stockList" style="min-width: 100px" v-show="menu_dic[10502]">库存</el-menu-item>
                <el-menu-item index="checkStock" style="min-width: 100px" v-show="menu_dic[10503]">盘库</el-menu-item>
                <el-menu-item index="adjust" style="min-width: 100px" v-show="menu_dic[10507]">调拨</el-menu-item>
                <el-menu-item index="totalMTOOut" style="min-width: 100px" v-show="menu_dic[10504]">MTO出库</el-menu-item>
                <el-menu-item index="totalMTSOut" style="min-width: 100px" v-show="menu_dic[10505]">MTS出库</el-menu-item>
                <el-menu-item index="totalOutWareDoc" style="min-width:100px" v-show="menu_dic[10506]">
                  出库汇总单
                </el-menu-item>
                <el-menu-item index="pickingDoc" style="min-width: 100px" v-show="menu_dic[10602]">领料出库</el-menu-item>
                <el-menu-item index="pickingDocReturn" style="min-width: 100px" v-show="menu_dic[10517]">领料退货单
                </el-menu-item>
                <el-menu-item index="stockWarning" style="min-width:100px" v-show="menu_dic[10513]">库存预警</el-menu-item>
                <el-menu-item index="warehouseArea" style="min-width:100px" v-show="menu_dic[10510]">仓库区域</el-menu-item>
                <el-menu-item index="warehousePosition" style="min-width:100px" v-show="menu_dic[10511]">
                  库位管理
                </el-menu-item>
                <el-menu-item index="temZoneManage" style="min-width:100px" v-show="menu_dic[10512]">温区管理</el-menu-item>
                <el-menu-item index="differenceBetweenOutboundAndAcceptance" style="min-width:100px"
                  v-show="menu_dic[10518]">出库验收差异</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="7" v-show="menu_dic[107]">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span slot="title">客户管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="customerList" style="min-width:100px" v-show="menu_dic[10700]">客户列表</el-menu-item>
                <el-menu-item index="releationManage" style="min-width:100px" v-show="menu_dic[10701]">
                  第三方供货关系管理
                </el-menu-item>
                <el-menu-item index="clientGroup" style="min-width: 100px" v-show="menu_dic[10702]">
                  项目点分组管理
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="21" v-show="menu_dic[122]">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span slot="title">供应商管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="supplierManage" style="min-width: 100px" v-show="menu_dic[12201]">
                  供应商列表
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="9" v-show="menu_dic[108]">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span slot="title">系统配置</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="kindManage" style="min-width: 100px" v-show="menu_dic[10805]">分类管理</el-menu-item>
                <!-- <el-menu-item index="sellOrderCustomPrint" style="min-width: 100px" v-show="menu_dic[11402]">自定义打印</el-menu-item> -->
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="28" v-show="menu_dic[124]">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span slot="title">生产加工</span>
              </template>
              <el-menu-item-group>
                <!-- <el-menu-item index="proPickingShopCar" style="min-width: 100px" v-show="menu_dic[11201]">购物车
                </el-menu-item> -->
                <el-menu-item index="proPickingDoc" style="min-width: 100px" v-show="menu_dic[12401]">
                  生产领料单
                </el-menu-item>
                <el-menu-item index="proPickingDocReturn" style="min-width: 100px" v-show="menu_dic[12411]">
                  生产领料退库单
                </el-menu-item>
                <el-menu-item index="productionSet" style="min-width: 100px" v-show="menu_dic[12402]">
                  BOM管理
                </el-menu-item>
                <el-menu-item index="productDepartment" style="min-width: 100px" v-show="menu_dic[12403]">
                  生产部门管理
                </el-menu-item>
                <el-menu-item index="dishManagement" style="min-width: 100px" v-show="menu_dic[12404]">
                  菜品BOM管理
                </el-menu-item>
                <el-menu-item index="proWarehousing" style="min-width: 100px" v-show="menu_dic[12405]">
                  生产入库
                </el-menu-item>
                <el-menu-item index="proReceipt" style="min-width: 100px" v-show="menu_dic[12406]">
                  生产入库单
                </el-menu-item>
                <el-menu-item index="packageSet" style="min-width: 100px" v-show="menu_dic[12407]">
                  套餐配置
                </el-menu-item>
                <el-menu-item index="mealGroup" style="min-width: 100px" v-show="menu_dic[12408]">
                  菜单管理
                </el-menu-item>
                <el-menu-item index="mealCountSet" style="min-width: 100px" v-show="menu_dic[12409]">
                  就餐人数管理
                </el-menu-item>
                <el-menu-item index="totalSellProducts" style="min-width: 100px" v-show="menu_dic[12410]">
                  生产汇总单
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="20" v-show="menu_dic[120]">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span slot="title">产品管理</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="categoryManage" style="min-width:100px" v-show="menu_dic[12001]">
                  品类管理
                </el-menu-item>
                <el-menu-item index="useSku" style="min-width:100px" v-show="menu_dic[12002]">产品列表</el-menu-item>
                <el-menu-item index="staticSku" style="min-width: 100px" v-show="menu_dic[12003]">标准SKU</el-menu-item>
                <el-menu-item index="canInput" style="min-width: 100px" v-show="menu_dic[12004]">可入库产品</el-menu-item>
                <el-menu-item index="specialOut" style="min-width: 100px" v-show="menu_dic[12005]">特殊出库产品</el-menu-item>
                <el-menu-item index="productTax" style="min-width: 100px" v-show="menu_dic[12006]">产品税率</el-menu-item>
                <el-menu-item index="productApplication" style="min-width: 100px"
                  v-show="menu_dic[12007]">新品申请上架</el-menu-item>
                <el-menu-item index="productStockingPlan" style="min-width: 100px"
                  v-show="menu_dic[12008]">产品备货方案</el-menu-item>
                <el-menu-item index="unpackInfo" style="min-width: 100px" v-show="menu_dic[12009]">拆箱查询</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="13" v-show="menu_dic[113]">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span slot="title">报表</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="profitLossTable" style="min-width: 100px" v-show="menu_dic[11300]">
                  盘库盈亏表
                </el-menu-item>
                <el-menu-item index="historyInStock" style="min-width: 100px" v-show="menu_dic[11301]">
                  历史入库单
                </el-menu-item>
                <el-menu-item index="historyOut" style="min-width: 100px" v-show="menu_dic[11302]">历史出库单</el-menu-item>
                <el-menu-item index="returnWarehouse" style="min-width: 100px" v-show="menu_dic[11304]">
                  销售退库单
                </el-menu-item>
                <el-menu-item index="returnProduct" style="min-width: 100px" v-show="menu_dic[11305]">
                  采购退货单
                </el-menu-item>
                <el-menu-item index="purchaseReturnStockOut" style="min-width: 100px" v-show="menu_dic[11316]">
                  采购退货出库单
                </el-menu-item>
                <el-menu-item index="returnGoods" style="min-width: 100px" v-show="menu_dic[11315]">销售退货单</el-menu-item>
                <el-menu-item index="salesStatements" style="min-width: 100px" v-show="menu_dic[11306]">
                  销售报表
                </el-menu-item>
                <el-menu-item index="grossProfit" style="min-width: 100px" v-show="menu_dic[11307]">毛利表</el-menu-item>
                <el-menu-item index="purchase" style="min-width: 100px" v-show="menu_dic[11308]">采购报表</el-menu-item>
                <el-menu-item index="TCGrossProfit" style="min-width: 100px" v-show="menu_dic[11310]">
                  客户毛利表
                </el-menu-item>
                <el-menu-item index="priceChangeChart" style="min-width: 100px" v-show="menu_dic[11311]">
                  采购价变化趋势
                </el-menu-item>
                <el-menu-item index="sellOrderReturn" style="min-width: 100px" v-show="menu_dic[11312]">
                  销售退货单
                </el-menu-item>
                <el-menu-item index="productRankList" style="min-width: 100px" v-show="menu_dic[11313]">
                  商品销售排行
                </el-menu-item>
                <el-menu-item index="singleRange" style="min-width: 100px" v-show="menu_dic[11314]">
                  总仓单品毛利表
                </el-menu-item>
                <el-menu-item index="orderCostGrossProfit" style="min-width: 100px" v-show="menu_dic[11317]">
                  订单成本毛利表
                </el-menu-item>
                <el-menu-item index="singleSalesSummary" style="min-width: 100px" v-show="menu_dic[11318]">
                  项目单品销售汇总
                </el-menu-item>
                <el-menu-item index="deliveryDiscrepancy" style="min-width: 100px" v-show="menu_dic[11319]">
                  送货差异表
                </el-menu-item>
                <el-menu-item index="itemSalesSchedule" style="min-width: 100px" v-show="menu_dic[11320]">
                  项目单品销售明细表
                </el-menu-item>
                <el-menu-item index="SupplierPurchaseSchedule" style="min-width: 100px" v-show="menu_dic[11321]">
                  供应商单品采购明细表</el-menu-item>
                <el-menu-item index="projectPointGrossProfitTable" style="min-width: 100px" v-show="menu_dic[11322]">
                  项目点单品毛利表</el-menu-item>
                <el-menu-item index="businessGrossProfitTable" style="min-width: 100px" v-show="menu_dic[11323]">
                  业务部毛利表
                </el-menu-item>
                <el-menu-item index="warehouseTransceiverList" style="min-width: 100px" v-show="menu_dic[11324]">
                  仓库收发明细表
                </el-menu-item>
                <el-menu-item index="purchasePriceDifferenceTable" style="min-width: 100px" v-show="menu_dic[11325]">
                  采购部差价表
                </el-menu-item>
                <el-menu-item index="supplierSingleItemProcurementSummary" style="min-width: 100px"
                  v-show="menu_dic[11326]">
                  供应商单品采购汇总表
                </el-menu-item>
                <el-menu-item index="projectSalesDailySummary" style="min-width: 100px" v-show="menu_dic[11327]">
                  项目销售日汇总表
                </el-menu-item>
                <el-menu-item index="orderProductGrossProfitTable" style="min-width: 100px" v-show="menu_dic[11328]">
                  订单产品毛利表
                </el-menu-item>
                <el-menu-item index="purchaseLedger" style="min-width: 100px" v-show="menu_dic[11329]">
                  进销台帐
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="25" v-show="menu_dic[115]">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span slot="title">财务中心</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="bankAccount" style="min-width: 100px" v-show="menu_dic[11501]">银行账户</el-menu-item>
                <!-- <el-menu-item index="cashFlow" style="min-width:100px" v-show="menu_dic[11502]">实时现金流</el-menu-item> -->
                <el-menu-item index="customerSettlement" style="min-width:100px" v-show="menu_dic[11502]">
                  客户结算
                </el-menu-item>
                <el-menu-item index="supplierBalance" style="min-width: 100px" v-show="menu_dic[11503]">
                  供应商结算
                </el-menu-item>
                <el-menu-item index="supplierQuickBalance" style="min-width: 100px" v-show="menu_dic[11508]">
                  供应商快捷结算
                </el-menu-item>
                <el-menu-item index="invoicingLedger" style="min-width: 100px" v-show="menu_dic[11504]">
                  进销存台账
                </el-menu-item>
                <el-menu-item index="incomeReport" style="min-width: 100px" v-show="menu_dic[11505]">
                  收入上报
                </el-menu-item>
                <el-menu-item index="financeCloseBill" style="min-width: 100px" v-show="menu_dic[11506]">
                  关账设置
                </el-menu-item>
                <el-menu-item index="invoiceList" style="min-width: 100px" v-show="menu_dic[11507]">
                  发票列表
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="23" v-show="menu_dic[119]">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span slot="title">运营中心</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="costReport" style="min-width: 100px" v-show="menu_dic[11903]">费用上报</el-menu-item>
                <el-menu-item index="clearingDetail" style="min-width: 100px" v-show="menu_dic[11901]">
                  消洗记录
                </el-menu-item>
                <!-- <el-menu-item index="cashFlow" style="min-width:100px" v-show="menu_dic[11502]">实时现金流</el-menu-item> -->
                <el-menu-item index="accountManager" style="min-width:100px" v-show="menu_dic[11902]">
                  人员管理
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="27" v-show="menu_dic[123]">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span slot="title">食品安全</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="contractManage" style="min-width: 100px" v-show="menu_dic[12301]">
                  资质管理
                </el-menu-item>
                <el-menu-item index="qualificatManage" style="min-width: 100px" v-show="menu_dic[12302]">
                  资质上传
                </el-menu-item>
                <el-menu-item index="pesticideResidueDetection" style="min-width: 100px" v-show="menu_dic[12303]">
                  农残检测
                </el-menu-item>
                <el-menu-item index="downloadQualificat" style="min-width: 100px" v-show="menu_dic[12304]">
                  采购品资质下载
                </el-menu-item>
                <el-menu-item index="qualificationInspection" style="min-width: 100px" v-show="menu_dic[12305]">
                  资质检验
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="18" v-show="menu_dic[114]">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span slot="title">设置</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="setting" style="min-width: 100px" v-show="menu_dic[11400]">页面条数设置</el-menu-item>
                <el-menu-item index="generalSettings" style="min-width: 100px" v-show="menu_dic[11401]">
                  通用设置
                </el-menu-item>
                <el-menu-item index="templatePrint" style="min-width: 100px" v-show="menu_dic[11402]">
                  打印设置
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="19" v-show="menu_dic[117]">
              <template slot="title">
                <i class="el-icon-menu"></i>
                <span slot="title">数据分析</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="dataBoard" style="min-width: 100px" v-show="menu_dic[11700]">数据看板</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <div class="we"></div>
          </el-menu>
        </el-scrollbar>
      </el-col>
      <el-col :span="21" :offset="3" class="layout-main-content">
        <div class="layout-content">
          <v-tags></v-tags>
          <div class="layout-content-main">
            <el-breadcrumb class="breadcrumb" separator=">" style="font-size: 18px;">
              <!--默认给一个首页的跳转-->
              <!--              <el-breadcrumb-item :to="{ path: '/welcome' }">首页</el-breadcrumb-item>-->
              <!--面包屑列表-->
              <el-breadcrumb-item v-for='(item, index) in this.循环面包屑' :key='index' :to="item.path">
                {{ item.meta.title }}
              </el-breadcrumb-item>
            </el-breadcrumb>
            <div class="router的样式">
              <router-view></router-view>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 修改密码模态框 -->
    <el-dialog title="修改密码" :visible.sync="centerDialogVisible" center width="600px">
      <el-form :model="passForm" ref="passForm" label-position="left" :rules="rules" size="small"
        style="padding-top: 0; margin-top: 0">
        <el-form-item label="旧 密 码：" prop="oldpass" :label-width="formLabelWidth">
          <label slot="label">旧&nbsp;&nbsp;密&nbsp;&nbsp;码：</label>
          <el-input v-model="passForm.oldpass" auto-complete="off" type="password"></el-input>
        </el-form-item>
        <el-form-item label="新 密 码：" prop="newpass" :label-width="formLabelWidth">
          <label slot="label">新&nbsp;&nbsp;密&nbsp;&nbsp;码：</label>
          <el-input v-model="passForm.newpass" auto-complete="off" type="password"></el-input>
        </el-form-item>
        <el-form-item label="确认密码：" prop="repass" :label-width="formLabelWidth">
          <el-input v-model="passForm.repass" auto-complete="off" type="password"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="centerDialogVisible = false">取 消</el-button>
        <el-button size="small" @click="submitForm('passForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 调试工具：仅本地开发环境挂载，后续功能在组件内按 tab 扩展 -->
    <dev-tool v-if="isDevEnv" />
  </div>
</template>
<script>
import { logout, editPass } from 'api/login';
import crypto from '@/assets/common/cryptoJ';
import bus from '@/components/base/bus';
import VTags from '@/components/base/Tags';
import DevTool from '@/components/base/DevTool';
import http from '@/assets/common/http';
import { loginExecution } from '@/assets/common/loginExecution';
import util from '@/assets/common/util';

export default {
  components: {
    VTags,
    DevTool,
  },
  // 菜单push路由
  async mounted () {
    await util.getUnreadInformation(this);

    this.changeMenu(this.$route.name);
    // 设置价格差异提醒
    this.$nextTick(() => {
      if (this.timer) {
        clearInterval(this.timer);
      }
      if (sessionStorage.getItem('PRICE_MODE') == 2 && sessionStorage.getItem('asyncRouterMap').includes('10311')) {
        this.priceDifferenceAlert();
        this.timer = setInterval(this.priceDifferenceAlert, 1800000);
      }
    });
  },
  watch: {
    $route (to) {
      this.changeMenu(to.name);
      this.$router.push({ name: to.name });
      this.activeIndex = to.name;
      this.面包屑数据();
    },
  },
  data () {
    // 修改密码验证
    const validatePass0 = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('请输入原始密码'));
      }
      callback();
    };
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'));
      } else {
        if (this.passForm.newpass !== 'code') {
          this.$refs.passForm.validateField('repass');
        }
        callback();
      }
    };
    const validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请确认新密码'));
      } else if (value !== this.passForm.newpass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    const validateCheck = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('验证码不能为空'));
      }
      callback();
    };
    return {
      // 仅本地开发环境（npm run dev）挂载调试工具
      isDevEnv: process.env.NODE_ENV === 'development',
      循环面包屑: [],
      // 菜单权限字典，由后端下发的菜单列表在 forMenu 中动态构建
      menu_dic: {},
      shopName: sessionStorage.getItem('company'),
      managername: sessionStorage.getItem('name'),
      // activeName: 'companyAdmin',
      centerDialogVisible: false,
      passForm: {
        oldpass: '',
        newpass: '',
        repass: '',
        check: '',
      },
      rules: {
        oldpass: [
          { validator: validatePass0, trigger: 'blur' },
        ],
        newpass: [
          { validator: validatePass, trigger: 'blur' },
        ],
        repass: [
          { validator: validatePass2, trigger: 'blur' },
        ],
        check: [
          { validator: validateCheck, trigger: 'blur' },
        ],
      },
      formLabelWidth: '100px',
      lkdLogo: this.$util.publicLogo() || '',
      activeIndex: this.$route.name || '',
      PRICE_MODE: sessionStorage.getItem('PRICE_MODE'),
      timer: undefined,
    };
  },
  created () {
    this.循环面包屑 = JSON.parse(sessionStorage.getItem('存起来的面包屑'));
    this.forMenu();
    // 监听tags标签传递的事件
    bus.$on('tags', (msg) => {
      const arr = [];
      for (let i = 0, len = msg.length; i < len; i++) {
        // eslint-disable-next-line no-unused-expressions
        msg[i].name && arr.push(msg[i].name);
      }
      this.tagsList = arr;
    });

    loginExecution();
  },
  computed: {
    hasUnreadInformation () {
      return this.$store.getters.hasUnreadInformation;
    },
    hasUnfinishedInformation () {
      return this.$store.getters.hasUnfinishedInformation;
    },
    cacheRouter () {
      return JSON.parse(sessionStorage.getItem('asyncRouterMap'));
    },
  },
  methods: {
    跳转预约下载 () {
      this.$router.push({ path: '/appointmentHandling' });
    },
    点击面包屑 (item) {
      this.$router.push({
        path: item.path,
      });
    },
    面包屑数据 () {
      const 面包屑序号 = typeof (this.$router.history.current.meta.breadNumber) !== 'undefined' ? this.$router.history.current.meta.breadNumber : 1;
      // 获取当前页面的名字和路由，并组合成新的对象
      const 当前面包屑 = { title: this.$router.history.current.meta.title };
      const 新面包屑 = { meta: 当前面包屑, path: this.$router.history.current.path };
      let 初始化面包屑 = [];
      // 初始化面包屑  vuexBreadList    面包屑序号   breadNumber
      if (面包屑序号 !== 1) {
        // 当前面包屑非一级面包屑合集大于1时才会 拿到所有面包屑
        初始化面包屑 = JSON.parse(sessionStorage.getItem('存起来的面包屑'));
      }
      if (面包屑序号 < 初始化面包屑.length) {
        // "回退"面包屑----判断条件：当前路由的 序号 小于初始化面包屑的长度
        初始化面包屑.splice(面包屑序号 - 初始化面包屑.length, 初始化面包屑.length - 面包屑序号);
      }
      if (面包屑序号 > 初始化面包屑.length) {
        // 添加面包屑----判断条件：当前路由breadNumber大于vuexBreadList的长度
        初始化面包屑.push(新面包屑);
      }
      sessionStorage.setItem('存起来的面包屑', JSON.stringify(初始化面包屑));
      this.循环面包屑 = 初始化面包屑;
    },
    forMenu () {
      const menuDic = {};
      // 后端下发的菜单码全部置为可见
      (this.cacheRouter || []).forEach((menu) => {
        menuDic[menu.MENU_CODE] = 1;
      });
      // 资质检验无菜单码，默认可见
      menuDic[12305] = 1;
      // 整体替换对象才能触发响应式更新
      this.menu_dic = menuDic;
    },
    selectMenu (name) {
      sessionStorage.setItem('pageRouter', name);
      this.$router.push({ name }); // push()方法设置路由
    },
    changeMenu (name) {
      this.activeName = name;
    },
    // ---------------------------------注销
    logout () {
      this.$confirm('您确认退出吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const data = {};
        logout(data).then((result) => {
          sessionStorage.removeItem('session');
          sessionStorage.removeItem('userId');
          sessionStorage.clear();
          this.$router.push({ name: 'login' });
          window.location.reload();
        }).catch((error) => {
          this.$message.show({ type: 'error', text: error });
        });
      }).catch(() => {
        this.$message.show({ type: 'info', text: '取消操作' });
      });
    },
    // 修改密码
    submitForm (formName) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          if (this.passForm.newpass == 123456) {
            this.$message.show({ text: '不能修改为初始密码', type: 'error' });
            document.body.style.cursor = 'default';
          } else {
            this.$refs[formName].validate((valid) => {
              if (valid) {
                // 修改密码加密
                const new_passWord = crypto.encrypt(
                  this.passForm.newpass,
                  'zAr6egnLKD9S4T2k',
                );
                const oldpass = crypto.encrypt(
                  this.passForm.oldpass,
                  'zAr6egnLKD9S4T2k',
                );
                const data = {
                  NEW_PASSWORD: new_passWord,
                  OLD_PASSWORD: oldpass,
                };
                editPass(data)
                  .then((result) => {
                    // http请求执行成功的回调
                    this.$router.push({ path: '/' });
                    this.$message.show({
                      text: '修改成功，重新返回登录',
                      type: 'success',
                    });
                    this.$refs[formName].resetFields();
                    document.body.style.cursor = 'default';
                  })
                  .catch((error) => {
                    this.$message.show({
                      showClose: true,
                      text: error,
                      type: 'error',
                    });
                    document.body.style.cursor = 'default';
                  });
              } else {
                document.body.style.cursor = 'default';
                return false;
              }
            });
          }
        } finally { }
      }
    },
    priceDifferenceAlert () {
      const params = {
        SERVICE_ID: '10041',
        OTYPE: 38,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        TYPE: 'all',
      };
      http.post(params).then((result) => {
        const that = this;
        if (result.length) {
          this.$notify({
            title: '客户价格与己方价格存在差异！',
            message: '点击确认',
            type: 'warning',
            duration: 0,
            onClick: () => {
              that.$router.push({ name: 'customerPricingDifferenceQuery' });
              this.$notify.closeAll();
            },
            // position: 'top-left',
          });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>
<style>
.btnSty {
  color: #000;
}

.we {
  height: 55px;
}

.layout {
  background: #f5f7f9;
  position: relative;
  height: 100%;
  width: 100%;
}

.layout-menu-left {
  position: fixed;
  background: #464c5b;
  left: 0;
  height: 100%;
  min-width: 130px;
  margin-top: 51px;
  z-index: 10;
  overflow: hidden;
}

.layout-main-content {
  background: #f5f7f9;
  position: absolute;
  /* margin-top: 61px; */
  margin-top: 46px;
}

.layout-header {
  z-index: 10;
  position: fixed;
  width: 100%;
  background: #252323;
  line-height: 48px;
  text-align: right;
  border-bottom: 1px solid #505664;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
}

.layout-header-font {
  font-weight: bold;
  font-size: 14px;
  cursor: pointer;
  margin-right: 20px;
}

.layout-header-icon {
  font-size: 25px;
  color: #2d8cf0;
  position: relative;
  left: 0;
  top: 4px;
  margin-right: 5px;
}

.layout-content-main {
  margin-top: 40px;
  padding: 10px;
  background: #fff;
}

.router的样式 {
  padding: 10px;
  background: #fff;
}

.layout-content {
  margin: 15px;
  overflow: hidden;
  background: #f5f7f9;
  border-radius: 4px;
}

.layout-header-logo {
  height: 50px;
  width: 210px;
  float: left;
  position: relative;
}

.layout-header-logo img {
  margin-right: 26%;
  height: 40px;
  margin-top: 5px;
  object-fit: contain;
}

.el-icon-arrow-down {
  display: none !important;
}

.el-scrollbar_wap {
  overflow-x: hidden;
}

.page-scroll {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/base/Public.vue